module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_07.dot-a7230843306a74f59ece2046e97d9bb5.svg";